import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';

export default function Form({ children, ...props }) {
  return (
    <S.Form {...props}>
      {children.map(component => {
        return component;
      })}
    </S.Form>
  );
}

Form.defaultProps = {
  children: <></>,
};

Form.propTypes = {
  children: PropTypes.node,
};
